import React, { createContext, useState, useEffect } from "react";

export const LangContext = createContext();

export const LangProvider = ({ children }) => {
	const validLangs = ["es", "pt", "en"];

	const getLangFromPath = (path) => {
		const langFromPath = path.split("/")[1];
		return validLangs.includes(langFromPath) ? langFromPath : "es";
	};

	const [lang, setLang] = useState(() => {
		const urlLang = getLangFromPath(window.location.pathname);
		const storedLang = localStorage.getItem("lang");
		return storedLang && validLangs.includes(storedLang) ? storedLang : urlLang;
	});

	const changeLang = (newLang) => {
		if (!validLangs.includes(newLang)) return;

		setLang(newLang);
		localStorage.setItem("lang", newLang);

		const segments = window.location.pathname.split("/");
		segments[1] = newLang;
		const newPath = segments.join("/") || "/";

		window.history.pushState({}, "", newPath);
		window.dispatchEvent(new PopStateEvent("popstate"));
	};

	useEffect(() => {
		const initialUrlLang = getLangFromPath(window.location.pathname);
		if (initialUrlLang) {
			setLang(initialUrlLang);
			localStorage.setItem("lang", initialUrlLang);
		}

		const handlePopState = () => {
			const urlLang = getLangFromPath(window.location.pathname);
			setLang(urlLang);
			localStorage.setItem("lang", urlLang);
		};

		window.addEventListener("popstate", handlePopState);
		return () => window.removeEventListener("popstate", handlePopState);
	}, []);

	return (
		<LangContext.Provider value={{ lang, changeLang }}>
			{children}
		</LangContext.Provider>
	);
};
